"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as i } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: r, size: c = 24 } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = i(), e = r !== null && r !== void 0 ? r : s ? o.colors.inverse : o.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M18.425 3.5H5.57C3.6 3.5 2 5.12 2 7.117v6.51c0 1.872 1.413 3.418 3.214 3.599v2.552a.72.72 0 0 0 .713.722c.187 0 .37-.074.507-.213l3.004-3.038h8.992c1.97 0 3.57-1.62 3.57-3.617V7.117C22 5.125 20.395 3.5 18.425 3.5m2.144 10.132c0 1.195-.96 2.172-2.144 2.172H9.141a.7.7 0 0 0-.503.213l-1.998 2.02v-1.51a.72.72 0 0 0-.713-.723H5.57c-1.18 0-2.144-.972-2.144-2.172V7.117c0-1.195.96-2.172 2.144-2.172h12.855c1.18 0 2.144.972 2.144 2.172zm-6.249-1.45V8.567a.544.544 0 0 0-.411-.528.536.536 0 0 0-.604.287l-1.307 2.65-1.308-2.65a.54.54 0 0 0-.603-.287.54.54 0 0 0-.412.528v3.617c0 .3.238.542.535.542s.535-.241.535-.542v-1.32l.773 1.56a.532.532 0 0 0 .96 0l.772-1.56v1.32c0 .3.238.542.535.542s.535-.241.535-.542m-5.253-.92c0 .86-.64 1.463-1.554 1.463-.338 0-.63-.056-.905-.176a.545.545 0 0 1-.283-.713.533.533 0 0 1 .704-.287c.137.06.292.088.484.088.48 0 .48-.288.48-.38 0-.135-.032-.232-.64-.505-.302-.134-1.102-.49-1.102-1.39 0-.791.645-1.347 1.573-1.347.11 0 .398.01.7.093.283.078.452.38.374.667a.537.537 0 0 1-.658.38 1.8 1.8 0 0 0-.416-.056c-.05 0-.498.009-.498.26 0 .073 0 .189.461.393l.03.014c.511.24 1.25.587 1.25 1.495m7.109 1.463c.914 0 1.554-.602 1.554-1.464 0-.908-.739-1.255-1.25-1.495l-.03-.014c-.461-.204-.461-.32-.461-.394 0-.25.448-.26.498-.26.036 0 .228.005.416.056a.537.537 0 0 0 .658-.38.546.546 0 0 0-.375-.666 2.8 2.8 0 0 0-.7-.093c-.927 0-1.572.556-1.572 1.348 0 .898.8 1.255 1.102 1.389.608.273.64.37.64.505 0 .092 0 .38-.48.38a1.2 1.2 0 0 1-.485-.088.533.533 0 0 0-.704.287.545.545 0 0 0 .284.713c.274.12.567.176.905.176"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M18.425 3.5H5.57C3.6 3.5 2 5.12 2 7.117v6.51c0 1.872 1.413 3.418 3.214 3.599v2.552a.72.72 0 0 0 .713.722c.187 0 .37-.074.507-.213l3.004-3.038h8.992c1.97 0 3.57-1.62 3.57-3.617V7.117C22 5.125 20.395 3.5 18.425 3.5m2.144 10.132c0 1.195-.96 2.172-2.144 2.172H9.141a.7.7 0 0 0-.503.213l-1.998 2.02v-1.51a.72.72 0 0 0-.713-.723H5.57c-1.18 0-2.144-.972-2.144-2.172V7.117c0-1.195.96-2.172 2.144-2.172h12.855c1.18 0 2.144.972 2.144 2.172zm-6.249-1.45V8.567a.544.544 0 0 0-.411-.528.536.536 0 0 0-.604.287l-1.307 2.65-1.308-2.65a.54.54 0 0 0-.603-.287.54.54 0 0 0-.412.528v3.617c0 .3.238.542.535.542s.535-.241.535-.542v-1.32l.773 1.56a.532.532 0 0 0 .96 0l.772-1.56v1.32c0 .3.238.542.535.542s.535-.241.535-.542m-5.253-.92c0 .86-.64 1.463-1.554 1.463-.338 0-.63-.056-.905-.176a.545.545 0 0 1-.283-.713.533.533 0 0 1 .704-.287c.137.06.292.088.484.088.48 0 .48-.288.48-.38 0-.135-.032-.232-.64-.505-.302-.134-1.102-.49-1.102-1.39 0-.791.645-1.347 1.573-1.347.11 0 .398.01.7.093.283.078.452.38.374.667a.537.537 0 0 1-.658.38 1.8 1.8 0 0 0-.416-.056c-.05 0-.498.009-.498.26 0 .073 0 .189.461.393l.03.014c.511.24 1.25.587 1.25 1.495m7.109 1.463c.914 0 1.554-.602 1.554-1.464 0-.908-.739-1.255-1.25-1.495l-.03-.014c-.461-.204-.461-.32-.461-.394 0-.25.448-.26.498-.26.036 0 .228.005.416.056a.537.537 0 0 0 .658-.38.546.546 0 0 0-.375-.666 2.8 2.8 0 0 0-.7-.093c-.927 0-1.572.556-1.572 1.348 0 .898.8 1.255 1.102 1.389.608.273.64.37.64.505 0 .092 0 .38-.48.38a1.2 1.2 0 0 1-.485-.088.533.533 0 0 0-.704.287.545.545 0 0 0 .284.713c.274.12.567.176.905.176"
        })
    }));
}, u = m;
export { u as default };
